if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        //this.cartNotification = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        //formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    //this.cartNotification.renderContents(response)
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              //this.cartNotification.renderContents(response);
            }
            load_cart();
            setTimeout(function (e) {
              document.querySelector("body").classList.add("open-drawer");
              setTimeout(function (e) {
                console.log("hello");
                var swiper = new Swiper(".mySwiper", {
                  slidesPerView: "auto",
                  spaceBetween: 8,
                  pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                  },
                  navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  },
                  breakpoints: {
                    620: {
                      slidesPerView: "auto",
                      spaceBetween: 12,
                    },
                  },
                });

                (function () {
                  equalHeight(true);
                })();
                window.onresize = function () {
                  equalHeight(true);
                };
                function equalHeight(resize) {
                  var elements = document.querySelectorAll(
                      ".swiper-wrapper.product-grid .full-unstyled-link"
                    ),
                    allHeights = [],
                    i = 0;
                  if (resize === true) {
                    for (i = 0; i < elements.length; i++) {
                      elements[i].style.height = "auto";
                    }
                  }
                  for (i = 0; i < elements.length; i++) {
                    var elementHeight = elements[i].clientHeight;
                    allHeights.push(elementHeight);
                  }
                  for (i = 0; i < elements.length; i++) {
                    elements[i].style.height =
                      Math.max.apply(Math, allHeights) + "px";
                    if (resize === false) {
                      elements[i].className = elements[i].className + " show";
                    }
                  }
                }
              }, 500);
            }, 500);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
